/*
 * File: c:\Users\j.mazat\Desktop\Moby\MobyFleet\mobyfleet_backoffice\src\Content\Pricing\PricingHolder\pricing.tsx
 * Project: c:\Users\j.mazat\Desktop\Moby\MobyFleet\mobyfleet_backoffice
 * Created Date: Tuesday August 20th 2024
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Tuesday August 20th 2024 4:58:26 pm
 * Modified By: the developer formerly known as Jonathan Mazat at <you@you.you>
 * -----
 * Copyright (c) 2024 Autobuy SAS
 * -----
 */

import { PrincingTypeEnum } from "Type/pricing.type";
import translator from "MultiLanguage/TranslationWrapper";
import Config from "Config/Config";
import Styles from "Content/Pricing/PricingHolder/pricing.module.css";
import PriceList from "../PriceList/priceList";
import { useState } from "react";

type PricingProps = {
    editable: boolean,
    deletePricing?: (type: PrincingTypeEnum, month?: number, milage?: number) => void,
    updatePricing?: (value: number, month: number, mileage: number, type: PrincingTypeEnum) => void,
    cb: Function,
    LOA: {},
    LLD: {}
};

export default function Pricing(props: PricingProps) {
    const [split, setSplit] = useState<boolean>(false);

    const manageSpliting = (nbCol: number) => {
        if (!split && nbCol > 4)
            setSplit(true);
        // if (nbCol < 5 && split)
        //     setSplit(false);
    };

    return (
        <div className={`${Styles.pricing} ${split ? Styles.priceSplit : ""}`}>
            <PriceList spliting={manageSpliting} editable={props.editable} setup={props.LOA} priceType="LOA" title={translator.decode("table.headers.Loa")} defaultMonth={Config.COMMON.LOA_MONTH} defaultMileage={Config.COMMON.LOA_MILEAGE} cb={() => {}} updatePricing={props.updatePricing} deletePricing={props.deletePricing} />
            <PriceList spliting={manageSpliting} editable={props.editable} setup={props.LLD} priceType="LLD" title={translator.decode("table.headers.Lld")} defaultMonth={Config.COMMON.LLD_MONTH} defaultMileage={Config.COMMON.LLD_MILEAGE} cb={() => {}} updatePricing={props.updatePricing} deletePricing={props.deletePricing} />
        </div>
    );
};

